import { Injectable } from '@angular/core';
import { BecareService } from './becare.service';
import { CNDoctor } from '../models/cndoctor';
import { Observable } from 'rxjs';
import { SNItemFactory } from '../models/snitemfactory';

@Injectable({
  providedIn: 'root'
})
export class DoctorService {

  searching = false;

  constructor(private becare: BecareService, private factory: SNItemFactory) { }

  search(searchstring): Observable<CNDoctor[]> {
    return new Observable(observer => {
      this.searching = true;
      this.becare.call('/doctor/search', [['q', searchstring]]).subscribe(result => {
        if (result.success === true && result.doctors !== undefined) {
          // Instanciates all doctor items
          const doctors: CNDoctor[] = this.factory.itemsFromJson(result.doctors);
          observer.next(doctors);
        } else {
          observer.error('error while searching for doctors');
        }
      }, error => {
        this.searching = false;
        observer.error(error);
      });
    });
  }
}
